module.exports = __webpack_public_path__ + "img/Bonelli.47991c3f.png";